import React from 'react';
import { cn } from '@/lib/cn';
import { SpriteIcon } from '@/components/ui/IconSprite';

export interface RatingProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Average rating value, e.g., 4.6 */
  value: number;
  /** Optional total review count, e.g., 230 */
  count?: number | null;
  /** Visual size of the rating */
  size?: 'sm' | 'md';
}

export function Rating({ value, count = null, size = 'sm', className, ...props }: RatingProps) {
  const iconSize = size === 'md' ? 'w-5 h-5' : 'w-4 h-4';
  const valueClass = size === 'md' ? 'text-body-1-high' : 'text-body-2-high';
  const countClass = size === 'md' ? 'text-body-1' : 'text-body-2';

  return (
    <div className={cn('flex items-center gap-1 shrink-0', className)} {...props}>
      {/* Sprited: one star per listing card means ~76 instances per grid page. */}
      <SpriteIcon
        name="star-filled"
        className={cn(value > 0 ? 'icon-rating' : 'icon-tertiary  ', iconSize)}
      />
      <span className={cn(valueClass, 'text-primary')}>{value > 0 ? value.toFixed(1) : '-'}</span>
      {typeof count === 'number' && (
        <span className={cn(countClass, 'text-secondary')}>({count})</span>
      )}
    </div>
  );
}
